<template>
  <div>
    <v-card flat width="100%">
      <v-card-title>Categories</v-card-title>
      <v-card-text>
        <v-col cols="12">
          <select-categories
            :clear="clear"
            v-model="category"
            :outlined="outlined"
          ></select-categories>
          <v-chip
            @click:close="deleteCategory(category)"
            class="mr-1 mb-1"
            close
            v-for="category in data"
            :key="category"
            >{{ category }}</v-chip
          >
        </v-col>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import SelectCategories from './SelectCategories'
export default {
  props: { value: { default: [] }, outlined: { default: false } },
  components: {
    SelectCategories
  },
  data() {
    return {
      category: '',
      data: [],
      clear: true
    }
  },
  watch: {
    category(value) {
      if (value) {
        if (!this.data.includes(value)) {
          this.data.push(value)
        }
        this.category = ''
        this.clear = !this.clear
      }
    },
    data: function(value) {
      this.$emit('input', value)
    },
    value: function(value) {
      this.data = value
    }
  },
  methods: {
    deleteCategory(category) {
      this.data = this.data.filter(i => i !== category)
      this.clear = !this.clear
    }
  }
}
</script>

<style></style>
